export function gtag_report_conversion({ value = 0, currency = 'INR', transaction_id = '', items = [], url }) {
  const callback = function () {
    if (typeof url !== 'undefined') {
      window.location = url;
    }
  };

  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'purchase', {
      send_to: 'AW-17362385162/UNNOCNnetvIaEIryg9dA',
      value: value,
      currency: currency,
      transaction_id: transaction_id,
      items: items,
      event_callback: callback,
    });
  } else {
    callback();
  }
  return false;
}